/* eslint-disable frontApplet/enforce-jsdoc */
import ILoadFileController from './ILoadFileController';

export default class CssLoadFileController implements ILoadFileController {
	public readonly name: string = 'css';

	constructor(private window: Window) {}

	public load(filePath: string, element: HTMLElement) {
		return new Promise<void>((resolve: () => void, reject: (error: Error) => void) => {
			const linkTag = this.window.document.createElement('link');
			linkTag.setAttribute('type', 'text/css');
			linkTag.setAttribute('rel', 'stylesheet');
			linkTag.setAttribute('href', filePath);
			linkTag.onerror = () => {
				reject(new Error('File "' + filePath + '" cannot be loaded'));
			};
			linkTag.onload = () => {
				console.info('File ' + filePath.substring(0, 100) + ' was loaded');
				resolve();
			};
			element.appendChild(linkTag);
		});
	}
}
